module.exports = "<div class=\"form-group\">\n    <div class=\"row\">\n        <div class=\"col-md-12\">\n            <select class=\"form-control\"\n                    nvDisabled\n                    #selectElem\n                    style=\"width: 100%\">\n            </select>\n        </div>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /opt/app/develop/src/app/components/nv-select/nv-select2.component.html
// module id = ../../../../../src/app/components/nv-select/nv-select2.component.html
// module chunks = 0